module.exports = __webpack_public_path__ + "static/media/0090_Medium.cc041489.jpg";